import type { SanityPageBuilderBannerSection, SanityPageBuilderSection } from "@ouster/shared";
import { BannerBlockView, isInlineVideo } from "~/features/blocks/inventory/banner";
import { toCraftMedia } from "~/features/sanity/media";
import { toCraftLinkArray } from "~/features/sanity/link";
import { SanityRichText } from "~/features/sanity/rich-text";
import { Media } from "~/features/ui/media";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderBannerSection;
  };
};
export function SanityBannerSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const text = sectionContent.text?.length ? <SanityRichText value={sectionContent.text} /> : undefined;
  const craftMedia = toCraftMedia(sectionContent.media);
  const isVideo = Boolean(craftMedia && isInlineVideo(craftMedia));
  return <BannerBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} isHighlighted={sectionContent.isHighlighted} isVideo={isVideo} link={toCraftLinkArray(sectionContent.link)} media={craftMedia ? videoRef => <Media {...craftMedia} imageProps={{
    fit: "cover",
    rounded: false,
    loading: "eager"
  }} inlineVideoProps={{
    fit: "cover",
    videoRef,
    rounded: false
  }} externalVideoProps={{
    fit: "cover",
    rounded: false
  }} /> : undefined} mode={sectionSettings?.mode || "light"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} tag={sectionContent.tag} text={text} />;
}